import React from 'react';

function ReplySignature(data) {

  return(
      <>
        {data.remark}
        <table width="560" style={{width: "560px", maxWidth: "100%"}}>
          <tbody>
          <tr>
            <td>
              <table width={data.logoWidth} cellPadding="0" style={{
                borderSpacing: 0,
                borderCollapse: 'collapse'
              }}>
                <tbody>
                <tr>
                  <td>
                    <img src={data.logo} alt="" width={data.logoWidth} />
                  </td>
                </tr>
                {
                  data.logoText !== '' &&
                  <tr>
                    <td style={{
                      fontSize: "10px",
                      textAlign: "right",
                      fontWeight: "bold",
                      fontFamily: 'arial',
                      lineHeight: '10px',
                      paddingTop: '3px'
                    }}
                    >
                      A member of <span style={{color: '#223d92', fontSize: '11px'}}>N<span style={{color: '#188d44'}}>E</span>TIS</span> Group
                    </td>
                  </tr>
                }
                </tbody>
              </table>
            </td>
          </tr>
          <tr>
            <td style={{fontFamily: "arial", color: "#2b1e8a", fontSize: "12px", padding: "5px 0 0 0", fontWeight: "bold", lineHeight: "19px"}} valign="bottom">
              {data.firstName} {data.lastName} - {data.positionAbr} <font style={{color: "#0f9c10"}}>{data.country}</font>
            </td>
          </tr>
          <tr>
            <td style={{padding: "0", fontSize: "9px", color: "#0372c3", fontFamily: "arial", lineHeight: "10px"}}>
              {
                (data.mobile && data.whatsapp && data.mobile === data.whatsapp) &&
                <>Mob / Whatsapp: {data.mobile}</>
              }
              {
                (data.mobile !== data.whatsapp) &&
                <>
                  {data.mobile && <>Mobile: {data.mobile}</>}
                  {(data.mobile && data.whatsapp) && <> | </>}
                  {data.whatsapp && <>Whatsapp: {data.whatsapp}</>}
                </>
              }
            </td>
          </tr>
          <tr>
            <td colSpan="2" style={{ padding: "0", fontSize: "9px"}}><img src={data.baseUrl + "/img/email-signature-generator/environment.jpg"} width="13" style={{width: "13px"}}/> <font style={{color: "#0f9c10", fontWeight: "bold"}}>please consider the environment before printing this email</font></td>
          </tr>
          <tr>
            <td colSpan="2" style={{fontSize: "9px", color: "#0372c3", paddingTop: "0"}}>This message is private and confidential. If you receive this message by error, please notify us and remove it from your system.</td>
          </tr>
          <tr>
            <td colSpan="2">
              <img src={data.replayImage} alt="" width={data.replayImageWidth}/>
            </td>
          </tr>

          </tbody>
        </table>
      </>
  )
}

export default ReplySignature;
